import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import Casinoengine from "../Casinoengine";
import CasinoContent from "../CasinoContent";
import { Tabs, Tab, Box } from "@mui/material";
import CasinoBusinessModal from "../CasinoBusinessModal";
import CasinoPlatform from "../CasinoPlatform";
import CasinoCompliance from "../CasinoCompliance";
import CasinoService from "../CasinoService";
import ScrollToTop from "../../component/ScrollToTop";

import engine from "../../images/casinoengine/engine.webp"

const CasinoTopHeader = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const changeActiveTab = (number) => {
    setActiveTab(number);
  };
  return (
    <>
      {activeTab && <ScrollToTop />}
      <section className="intro">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1>Casino Integration Platform</h1>
              <h2>
                The number one casino integration and productivity platform and
                the largest casino content library in the industry.
              </h2>
              <nav className="product-submenu">
                <Tabs value={activeTab} onChange={handleChange} centered>
                  <Tab label="Overview" />
                  <Tab label="Casino Content" />
                  <Tab label="Business Models" />
                  <Tab label="Platform Features" />
                  <Tab label="Compliance" />
                  <Tab label="Service" />
                </Tabs>
              </nav>
            </div>
          </div>
        </div>
        <img
          src={engine}
          className="floating-image"
        />
          <a href="#explore" className="explore"></a>
      </section>

      <Box sx={{ width: "100%" }}>
        <Box sx={{ mt: 2 }}>
          {activeTab === 0 && (
            <Casinoengine changeActiveTab={changeActiveTab} />
          )}
          {activeTab === 1 && <CasinoContent />}
          {activeTab === 2 && <CasinoBusinessModal />}
          {activeTab === 3 && <CasinoPlatform />}
          {activeTab === 4 && <CasinoCompliance />}
          {activeTab === 5 && <CasinoService />}
        </Box>
      </Box>
    </>
  );
};

export default CasinoTopHeader;
